export const environment = {
  production: true,
  version: '87b08200b4',
  site_version: 'SITE_VERSION'
};
